import {
  Button,
  Descriptions,
  Divider,
  EditButton,
  Icons,
  notification,
  PageHeader,
  Select,
  ShowButton,
  Space,
  Spin,
  Table,
  Typography,
  Form,
  message,
  ExportButton,
  Tooltip,
  Progress,
  Modal,
  Popconfirm,
} from '@pankod/refine-antd'
import {
  IResourceComponentsProps,
  useGetIdentity,
  useShow,
  useTable,
  useUpdate,
  useUpdateMany,
  useInvalidate,
  useCreate,
  useExport,
} from '@pankod/refine-core'
import { IEvaluationMain, IEvaluationDetails, IEvaluationRequests, IEvaluationEvaluators } from 'interfaces'
import { Col, Row, TableColumnsType, Tag } from 'antd'
import React, { useEffect, useState, useMemo } from 'react'
import { ShowCandidate } from './viewCandidate'
import { getDetailsById, getEvaluationDetails } from 'gql/query'
import { CSVLink } from 'react-csv'
// import XLSX from 'sheetjs-style'
import {
  createNotificationVerify,
  createNotificationVerifyForEvaluators,
  createNotificationFinalVerifyEvaluationIncharge,
  createNotificationFinalVerifyDeliveryManager,
  createNotificationFinalisedEvaluationIncharge,
  updateEvaluationRequestStatus,
  deleteCandidate,
} from 'gql/mutations'
import type { NotificationPlacement } from 'antd/es/notification'
import Permissions from 'permissions'
import { useUserContext } from 'context/user'
import { createMailForEvaluators, createMainVerify } from 'helpers'
import { TableRowSelection } from 'antd/es/table/interface'
import { exportToExcel } from 'exportToExcel'
import { allCandidateResultGenerating } from 'helpers/allCandidateResultGenerating'
import { candidateBulkReportGeneration } from 'helpers/candiateBulkReportGenerationCSV/canidateReportBulkReportGeneration'
import { deleteReportCardLinks } from 'helpers/evaluations/reportCardeDeletion'
import { updateReportCardVisibility } from 'helpers/evaluations/reportCardVisibility'
import { getMobileReportCardDownloadUrl, hasGeneratedReportCard } from 'helpers/reportCardDownload'

type Permission = {
  granted?: boolean
}
type FileDetails = {
  lastModified: any
  name: string
}
type QuestionAnswer = {
  id: string
  number: number
  option: string
  mark: number
  questionType: string
}
const { ExportOutlined, DownloadOutlined } = Icons
export const ShowEvaluation: React.FC<IResourceComponentsProps> = () => {
  const { data: user } = useGetIdentity()
  const invalidate = useInvalidate()
  const { userRole, evaluators: evaluatorList } = useUserContext()
  const { mutate } = useUpdate<IEvaluationRequests>()
  const [form] = Form.useForm<IEvaluationEvaluators>()
  const { mutate: updateEvaluators } = useUpdateMany<IEvaluationEvaluators>()
  const { mutate: updateEvaluatorStatus } = useUpdate<IEvaluationEvaluators>()
  // const [selectedCandidates, setSelectedRow] = useState<IEvaluationDetails[]>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [evaluatorData, setEvaluatorData] = useState<IEvaluationEvaluators>()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const [selectedEvaluators, setSelectedEvaluators] = useState([] as any[])
  const [showModal, setModal] = useState(false)
  const [details, setData] = useState<object>({})
  const fileReader = new FileReader()
  const [array, setArray] = useState<object[]>([])
  const [csvData, setCsvData] = useState<object[]>([])
  const [file, setFile] = useState<FileDetails>()
  const [background, setBackground] = useState('opacity1')
  const { mutate: updateEvaluationEvaluatord, isLoading: updateManyIsLoading } = useUpdateMany<IEvaluationDetails>()
  const [loading, setLoading] = useState(false)
  const [currentPaperDetails, setCurrentPaperDetails] = useState<QuestionAnswer[]>([])
  const [evaluationData, setEvaluationData] = useState<IEvaluationDetails[]>([])
  const [evaluators, setEvaluators] = useState([] as any[])
  const [mcqVerifiedBtnShow, showMCQVerifiedBtn] = useState(false)
  const { mutate: createEvaluationEvaluator } = useCreate<IEvaluationEvaluators>()
  const [availableEvaluator, setAvailableEvaluators] = useState<any[]>()
  const [shouldCreateMapping, setShouldCreateMapping] = useState<boolean>(true)
  const [editMode, setEditMode] = useState<boolean>(false)
  const [resultGreneration, setResultGeneration] = useState<boolean>(false)
  const [reportGenerate, setReportGenerate] = useState<boolean>(false)
  const [bulkReportData, setBulkReportData] = useState()
  const [sktDetails, setSktDetails] = useState()
  const [rcDownloadLoading, setRcDownloading] = useState<boolean>(false)
  const [rcDownloadButtonName, setRcDownloadButtonName] = useState<string>('')
  const [candiateReportcardDetails, setCandidateReportcardDetails] = useState<any>([])
  // const [rcMultipleDeletionLoading, setRcMultipleDeletionLoading] = useState<boolean>(false)

  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('file_upload'))
      setCreatePermission(Permissions.can(userRole).createAny('file_upload'))
      setEditPermission(Permissions.can(userRole).updateAny('file_upload'))
      setDeletePermission(Permissions.can(userRole).deleteAny('file_upload'))
    }
  }, [userRole])

  const getCandidateEvaluationDetails = async (id: string) => {
    const getEvaluationDetails = await getDetailsById(
      id,
      `candidate_report_data`,
      `evaluation_id`,
      `{score_card_url candidate_id candidate_name section_level_details is_visible}`
    )
    setCandidateReportcardDetails(getEvaluationDetails)
  }

  const { queryResult } = useShow<IEvaluationMain>({
    resource: 'evaluations',
    metaData: {
      fields: [
        'id',
        'name',
        'created_at',
        'evaluation_request_id',
        { paper: ['paper_smart_id', 'paper_id', { product: ['total_marks', 'name', 'tq', 'type'] }] },
        {
          evaluation_request: [
            'name',
            'request_id',
            'evaluator_ids',
            'created_by',
            'status',
            'id',
            'evaluation_in_charge',
            { test_events: ['name', 'mode_of_exam', ''] },
            { createdBy: ['email', 'displayName', 'id'] },
            {
              evaluators: ['id', 'evaluation_request_id', { evaluator: ['id', 'displayName'] }],
            },
          ],
        },
        { evaluators_assigned: ['id', 'evaluator_id', 'evaluation_id', { evaluator: ['id', 'displayName'] }] },
      ],
    },
  })

  let headers = [
    { label: 'ID', key: 'id' },
    { label: 'CandidateId', key: 'candidate_id' },
    { label: 'CandidateName', key: 'candidate_name' },
    { label: 'ApplicationId', key: 'application_id' },
  ]
  const { data, isLoading, refetch } = queryResult
  const record = data?.data

  const { tableQueryResult: evaluationDetails, setFilters } = useTable<IEvaluationDetails>({
    resource: 'evaluation_details',
    initialPageSize: 100000,
    permanentSorter: [
      {
        field: 'candidate_id',
        order: 'asc',
      },
    ],
    initialSorter: [
      {
        field: 'candidate_id',
        order: 'asc',
      },
    ],

    metaData: {
      fields: [
        'id',
        'candidate_id',
        'candidate_name',
        'application_id',
        'candidate_image',
        'answers',
        'total_score',
        'evaluation_id',
        'attempted',
        'correct',
        'evaluator_id',
        'tq',
        'skt_id',
        'is_attended',
        'is_eligible_for_result',
        'school_id',
        { evaluator: ['displayName'] },
        {
          evaluation: [
            'name',
            {
              evaluation_request: [
                {
                  evaluators: ['id', 'status', 'evaluator_id', { evaluator: ['displayName'] }],
                },
              ],
            },
          ],
        },
      ],
    },
  })
  useEffect(() => {
    setFilters([
      {
        field: 'evaluation_id',
        operator: 'eq',
        value: record?.id,
      },
    ])
  }, [record])
  useEffect(() => {
    let result = evaluationDetails?.data?.data?.[0]?.evaluation?.evaluation_request?.evaluators?.filter(
      (elem: any) => elem?.evaluator_id === user?.id
    )[0]
    if (result?.id) {
      setEvaluatorData(result)
    }
  }, [evaluationDetails?.data?.data])
  useEffect(() => {
    if (userRole === 'evaluators') {
      setFilters([
        {
          field: 'evaluator_id',
          operator: 'eq',
          value: user?.id,
        },
      ])
    }
    if (record && record?.id) {
      getCandidateEvaluationDetails(record.id)
    }
  }, [userRole, evaluationDetails?.data?.data])
  const showDetails = (record: any) => {
    setData(record)
    setModal(true)
  }

  //Delete candidate
  const deleteCandidateDetails = async (candidateDetails: any) => {
    try {
      const deleteDetails = await deleteCandidate(candidateDetails.id, candidateDetails.application_id)
      if (deleteDetails) {
        await evaluationDetails.refetch()
        message.success('Candidate evaluation details deleted successfully...')
      }
    } catch (err) {
      console.log(err, ':error while deleting')
      message.error('Something went wrong, please try again later...')
    }
  }

  const evaluationTestType = record?.paper?.product?.type?.toLowerCase() || 'tq'

  const columns: TableColumnsType<IEvaluationDetails> = [
    {
      title: 'Candidate Name',
      dataIndex: 'candidate_name',

      render: (_, record) => (
        <>
          <Typography.Text
            onClick={() => showDetails(record)}
            style={{
              width: 200,
              textAlign: 'left',
              color: '#6659FF',
              cursor: 'pointer',
            }}
          >
            {record?.candidate_name}
          </Typography.Text>
        </>
      ),
    },
    {
      dataIndex: 'candidate_id',
      title: 'Candidate Id',
    },
    {
      dataIndex: 'application_id',
      title: 'Application Id',
    },
    {
      dataIndex: 'total_score',
      title: 'Total Score',
    },
    {
      dataIndex: 'application_id',
      title: 'Score Card',
      render: (_, record) => {
        const candidateDetails = candiateReportcardDetails.find(({ candidate_id }: any) => candidate_id === record.application_id)
        return hasGeneratedReportCard(candidateDetails) ? (
          <>
            <Tooltip title={`View Score card - ${candidateDetails.candidate_name}`}>
              <a
                href={getMobileReportCardDownloadUrl(candidateDetails.candidate_id, evaluationTestType)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icons.EyeTwoTone style={{ fontSize: 16, color: '#7ba177' }} />
              </a>
            </Tooltip>
            {/* RC Link deletion */}
            <Popconfirm
              title="Are you sure you want to delete this candidate's score card link?"
              onConfirm={() =>
                deleteReportCardLinks({ candidateId: candidateDetails?.candidate_id, url: candidateDetails?.score_card_url })
                  .then(async (res: any) => {
                    if (res.status) {
                      const candidateReportData = candiateReportcardDetails.map((item: any) =>
                        item.candidate_id === candidateDetails?.candidate_id ? { ...item, score_card_url: null } : item
                      )
                      setCandidateReportcardDetails(candidateReportData)
                      message.success(res.message || 'Items deleted successfully..')
                    } else {
                      message.error(res.message || 'Unable to complete the deletion!')
                    }
                  })
                  .catch(err => message.error('server down!'))
              }
              okText="Yes"
              cancelText="No"
            >
              <Icons.DeleteOutlined style={{ marginLeft: '8px', color: '#c96969', cursor: 'pointer' }} />
            </Popconfirm>
          </>
        ) : (
          <Tooltip title={`Not Generated!`}>
            <Icons.StopOutlined style={{ fontSize: 16, color: '#c96969' }} />
          </Tooltip>
        )
      },
    },
    queryResult?.data?.data?.paper?.product?.tq
      ? {
          dataIndex: 'application_id',
          title: 'Digital Badge Eligibility',
          render: (_, record) => {
            const candidateDetails = candiateReportcardDetails.find(({ candidate_id }: any) => candidate_id === record.application_id)
            return queryResult?.data?.data?.paper?.product?.tq && candidateDetails?.section_level_details ? (
              candidateDetails?.section_level_details?.All_Items_Greater_Than30 &&
              (Number(candidateDetails?.section_level_details?.total_marks) / candidateDetails?.section_level_details?.total_paper_score) * 100 >=
                50 ? (
                <Tooltip title={`Eligible (${candidateDetails.candidate_name})`}>
                  <Icons.LikeFilled style={{ fontSize: 16, color: '#7ba177' }} />
                </Tooltip>
              ) : (
                <Tooltip title={`Not Eligible (${candidateDetails.candidate_name})`}>
                  <Icons.DislikeFilled style={{ fontSize: 16, color: '#1890ff' }} />
                </Tooltip>
              )
            ) : (
              <Tooltip title={`Not Generated!`}>
                <Icons.StopOutlined style={{ fontSize: 16, color: '#c96969' }} />
              </Tooltip>
            )
          },
        }
      : {},

    {
      dataIndex: 'is_attended',
      title: 'Is Attended',
      render: (_, record) => {
        return (
          <>
            {record?.is_attended ? (
              <Tooltip title={`Attended`}>
                <Icons.LikeFilled style={{ fontSize: 16, color: '#7ba177' }} />
              </Tooltip>
            ) : (
              <Tooltip title={`Not Attended`}>
                <Icons.DislikeFilled style={{ fontSize: 16, color: '#c96969' }} />
              </Tooltip>
            )}
          </>
        )
      },
    },
    {
      dataIndex: 'is_eligible_for_result',
      title: 'Is Eligible For Result',
      render: (_, record) => {
        return (
          <>
            {record?.is_eligible_for_result ? (
              <Tooltip title={`Eligible for Results`}>
                <Icons.LikeFilled style={{ fontSize: 16, color: '#7ba177' }} />
              </Tooltip>
            ) : (
              <Tooltip title={`Not eligible for Results`}>
                <Icons.DislikeFilled style={{ fontSize: 16, color: '#c96969' }} />
              </Tooltip>
            )}
          </>
        )
      },
    },

    {
      dataIndex: 'evaluator_id',
      title: 'Evaluator',
      render: (_, record) => record?.evaluator?.displayName,
    },
    {
      dataIndex: 'id',
      title: 'Actions',
      render: (application_id, evl) => {
        const candidateDetails = candiateReportcardDetails?.find(({ candidate_id }: any) => candidate_id === evl.application_id)
        let is_visible = candidateDetails?.is_visible || false
        return (
          <>
            <Popconfirm title="Are you sure to delete this candidate?" onConfirm={() => deleteCandidateDetails(evl)} okText="Yes" cancelText="No">
              <Button icon={<Icons.DeleteOutlined />} />
            </Popconfirm>
            <Popconfirm
              title={
                is_visible
                  ? 'Are you sure you want to hide the scorecard from the candidate?'
                  : 'Are you sure you want to make the scorecard visible to the candidate?'
              }
              onConfirm={async () => {
                await updateReportCardVisibility([{ candidate_id: evl?.application_id, visibility: is_visible }])
                if (record) {
                  await getCandidateEvaluationDetails(record?.id)
                }
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button
                icon={evl?.is_attended && is_visible && evl?.is_eligible_for_result ? <Icons.EyeFilled /> : <Icons.EyeInvisibleFilled />}
                style={{
                  color: evl?.is_attended && is_visible && evl?.is_eligible_for_result ? '#80bde0' : '#fa7070',
                  marginLeft: '5px',
                  opacity: evl?.is_attended && is_visible && evl?.is_eligible_for_result && candidateDetails ? '' : '0.5',
                }}
                disabled={!evl?.is_attended || !evl?.is_eligible_for_result || !candidateDetails}
              />
            </Popconfirm>
          </>
        )
      },
    },
  ]
  const handleCancel = () => {
    setData({})
    setModal(false)
  }

  const handleOnChange = (e: any) => {
    setBackground('opacity-blur')
    setLoading(true)
    // setLoading(true)
    // setShowUpload(false)
    setFile(e.target.files[0])
    // increase(20)
    handleOnSubmit(e.target.files[0])
  }
  useEffect(() => {
    let arr: object[] = []
    if (JSON.stringify(queryResult?.data?.data?.evaluation_request?.evaluators) !== '[]') {
      queryResult?.data?.data?.evaluation_request?.evaluators?.forEach((elem: any) => {
        if (!arr?.includes(elem?.id)) arr?.push(elem?.id)
      })
    }
    setSelectedEvaluators(arr)
  }, [queryResult?.data?.data])
  const uploadEvaluationDetails = async (data: any) => {
    // alert(2)
    let details: object[] = []
    details.push({ csv: data, total: evaluationDetails?.data?.data })
    fetch(`${process.env.REACT_APP_BACKEND_URL}/evaluation-other-upload`, {
      //  fetch('http://localhost:3001/evaluation-other-upload', {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      body: JSON.stringify(details),
      headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
    })
      .then(response => response.json())
      .then(resp => {
        console.log({ resp })
        if (resp?.statusMessage === 'Success') {
          setLoading(false)
          if (evaluatorData?.id) {
            updateEvaluatorStatus(
              {
                resource: 'evaluation_evaluators',
                id: evaluatorData?.id,
                values: {
                  status: 'Score Uploaded',
                },
              },
              {
                onSuccess: () => {
                  //  setSelectedRowKeys([])
                },
              }
            )
          }
          // evaluationDetails?.refetch()
          openNotification('bottomRight', 'Upload Success')
        } else {
          setLoading(false)
          openNotification('bottomRight', data?.statusMessage)
        }

        setBackground('opacity1')
        evaluationDetails?.refetch()
      })
  }
  const openNotification = (placement: NotificationPlacement, message: string) => {
    notification.success({
      message: `Notification`,
      description: message,
      placement,
    })
    evaluationDetails.refetch()
  }

  const handleEvaluatorChange = (value: string) => {
    let evaluatorAlreadyAssigned = false
    record?.evaluators_assigned?.forEach(mappedEval => {
      if (mappedEval?.evaluator_id === value) evaluatorAlreadyAssigned = true
    })
    setShouldCreateMapping(!evaluatorAlreadyAssigned)
  }

  const handleOnSubmit = (fs: any) => {
    if (fs) {
      fileReader.onload = function (event: any) {
        const csvOutput = event.target.result
        uploadEvaluationDetails(csvOutput)
        // csvFileToArray(csvOutput)
        //  increase(50)
      }

      fileReader.readAsText(fs)
    }
  }

  useEffect(() => {
    let arr: any[] | undefined = []
    if (JSON.stringify(queryResult?.data?.data?.evaluators_assigned) !== '[]') {
      arr = queryResult?.data?.data?.evaluators_assigned?.map(evaluator => evaluator?.evaluator)
    }
    arr ? setEvaluators(arr) : setEvaluators([])
  }, [queryResult?.data?.data])
  const verifyAndNext = () => {
    createMainVerify(queryResult?.data?.data)
    createNotificationVerify(queryResult?.data?.data, user?.id)
    createMailForEvaluators(queryResult?.data?.data, evaluators)
    createNotificationVerifyForEvaluators(queryResult?.data?.data, user?.id)
    updateEvaluators({
      resource: 'evaluation_evaluators',
      ids: selectedEvaluators,
      values: { evaluation_id: queryResult?.data?.data?.id },
    })
    mutate(
      {
        resource: 'evaluation_requests',
        id: queryResult?.data?.data?.evaluation_request?.id ?? '',
        values: { status: 'MCQ Verified' },
      },
      {
        onSuccess: () => {
          evaluationDetails?.refetch()
          invalidate({
            resource: 'evaluations',
            invalidates: ['detail'],
            id: record?.id,
          })
          // queryResult?.refetch()
        },
      }
    )
  }

  const onSelectChange = (selectedRowKeys: React.Key[]) => {
    console.log({ selectedRowKeys })
    setSelectedRowKeys(selectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
    getCheckboxProps: (record: any) => ({
      disabled: userRole === 'evaluators', // Column configuration not to be checked
      // name: record.name,
    }),
  }
  const hasSelected = selectedRowKeys.length > 0
  const onFinish = async (values: any) => {
    updateEvaluationEvaluatord(
      {
        resource: 'evaluation_details',
        ids: selectedRowKeys,
        values: {
          evaluator_id: values?.evaluator_id,
        },
      },
      {
        onSuccess: () => {
          setSelectedRowKeys([])
          evaluationDetails?.refetch()
          invalidate({
            resource: 'evaluations',
            invalidates: ['detail'],
            id: record?.id,
          })
          // queryResult?.refetch()
          form?.resetFields()
          // evaluationDetails?.refetch()
        },
      }
    )
    // check if the user is already assigned in evaluation evaluator

    shouldCreateMapping &&
      createEvaluationEvaluator(
        {
          resource: 'evaluation_evaluators',
          values: { evaluator_id: values?.evaluator_id, evaluation_id: record?.id, evaluation_request_id: record?.evaluation_request_id },
        },
        {
          onSuccess: () => {
            evaluationDetails?.refetch()
            invalidate({
              resource: 'evaluations',
              invalidates: ['detail'],
              id: record?.id,
            })
            // queryResult?.refetch()
            form?.resetFields()
            // evaluationDetails?.refetch()
          },
        }
      )
    setEditMode(false)
  }
  const finalVerify = () => {
    let result = evaluationDetails?.data?.data?.[0]?.evaluation?.evaluation_request?.evaluators?.filter(
      (elem: any) => elem?.evaluator_id === user?.id
    )[0]
    if (result?.id) {
      updateEvaluatorStatus(
        {
          resource: 'evaluation_evaluators',
          id: result?.id,
          values: {
            status: 'Verified',
          },
        },
        {
          onSuccess: () => {
            createNotificationFinalVerifyDeliveryManager(queryResult?.data?.data, user?.id, evaluatorData)
            createNotificationFinalVerifyEvaluationIncharge(queryResult?.data?.data, user?.id, evaluatorData)
            queryResult?.refetch()
            evaluationDetails?.refetch()
            updateEvaluationRequestStatus(record?.id).then((resp: any) => {
              if (resp?.evaluations?.length > 0) {
                let count = 0
                resp?.evaluations?.map((item: any) => {
                  item?.evaluation_request?.evaluators?.map((elem: any) => {
                    if (elem?.status === 'Verified') {
                      count++
                    }
                  })
                })
                if (count === evaluationDetails?.data?.data?.[0]?.evaluation?.evaluation_request?.evaluators?.length) {
                  mutate(
                    {
                      resource: 'evaluation_requests',
                      id: queryResult?.data?.data?.evaluation_request?.id ?? '',
                      values: { status: 'Score Finalised' },
                    },
                    {
                      onSuccess: () => {
                        createNotificationFinalisedEvaluationIncharge(queryResult?.data?.data, user?.id)
                      },
                    }
                  )
                } else {
                  mutate({
                    resource: 'evaluation_requests',
                    id: queryResult?.data?.data?.evaluation_request?.id ?? '',
                    values: { status: 'Score Upload In Progress' },
                  })
                }
              }
            })
          },
        }
      )
    }
    queryResult?.refetch()
    evaluationDetails?.refetch()
  }
  const showVerifyBtn = () => {
    let result = undefined
    if (JSON.stringify(evaluationDetails?.data?.data) !== '{}') {
      result = evaluationDetails?.data?.data?.filter((item: any) => item?.evaluator_id === null)
      console.log('check', JSON.stringify(result))
      if (JSON.stringify(result) !== '[]') {
        return true
      } else {
        return false
      }
    }
  }

  const exportData = async () => {
    let arr: object[] = []

    getEvaluationDetails(record?.id, user?.id).then((resp: any) => {
      if (resp?.evaluation_details) {
        resp?.evaluation_details?.map((item: any) => {
          arr.push({
            ApplicationId: item?.application_id,
            CandidateId: item?.candidate_id,
            CandidateName: item?.candidate_name,
            ID: item?.id,
          })
        })
      }
      exportToExcel(arr, 'format.xlsx')
    })
  }

  const availableEvaluators = useMemo(
    () =>
      editMode
        ? evaluatorList
        : evaluatorList?.filter(evalUser => {
            let userNotAssigned = true
            evaluators?.forEach(data => {
              if (data?.id === evalUser?.id) userNotAssigned = false
            })
            return userNotAssigned
          }),
    [evaluators, editMode, evaluatorList]
  )

  const storeAllResultsOfCandidate = async (allResults: any) => {
    try {
      setResultGeneration(true)
      if (allResults?.data.length > 0) {
        const result = await allCandidateResultGenerating(allResults)
        if (result?.status) {
          const addedResults = result?.response?.addedCandidateResults
          const existingResults = result?.response?.alreadyExisting
          const totalNumberOfResult = result?.response?.numberOfResults
          if (totalNumberOfResult === existingResults) {
            setResultGeneration(false)
            message.info(
              <>
                Action Not Required, Results are already generated. <br />
                You can now proceed to download the report cards or export the report data.
              </>
            )
          } else {
            if (record && record.id) {
              await getCandidateEvaluationDetails(record.id)
            }
            setResultGeneration(false)
            message.success(
              <>
                Added {addedResults} results out of {totalNumberOfResult}, and {existingResults} results already exist.
                <br />
                You can now proceed to download the report cards or export the report data.
              </>
            )
          }
        } else {
          setResultGeneration(false)
          message.error(result?.message)
        }
      } else {
        setResultGeneration(false)
        message.warning('Candidate result is missing ...')
      }
    } catch (err) {
      setResultGeneration(false)
      console.log(err, 'error from store all candidate results ')
    }
  }

  const generateBulkReport = async () => {
    try {
      setReportGenerate(true)
      if (evaluationDetails) {
        const candidatesEvalutaionDetails = evaluationDetails?.data?.data
        if (candidatesEvalutaionDetails) {
          const resposneFromCandidateBulkReportGeneration: any = await candidateBulkReportGeneration(candidatesEvalutaionDetails)
          if (resposneFromCandidateBulkReportGeneration?.status) {
            console.log()
            setBulkReportData(resposneFromCandidateBulkReportGeneration?.exportData)
            setReportGenerate(false)
            message.success('Data generated successfully, Please click Download Report button to download the report data.')
          } else {
            setReportGenerate(false)
            message.error(resposneFromCandidateBulkReportGeneration.message)
          }
        } else {
          setReportGenerate(false)
          message.error("Can't candidate data is missing")
        }
      } else {
        setReportGenerate(false)
        message.error('Uploaded results are missing!')
      }
    } catch (err) {
      setReportGenerate(false)
      console.log(err, 'error from bulk report generation')
    }
  }
  //Skt Data download
  const triggerExport = async () => {
    const exportData = await evaluationDetails?.data?.data.map(data => {
      return {
        name: data.candidate_name,
        candidate_id: data?.application_id,
        skt_id: `SKT_${data?.application_id}`,
        total: data?.total_score,
      }
    })
    exportToExcel(exportData, `SKT_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }

  // Download scorecards (Netlify mobile PDF links — no backend required)
  const downloadScoreCards = async (evaluationDetails: any) => {
    setRcDownloading(true)
    const downloadButtonNames = [
      'Preparing scorecard download links...',
      'Crunching numbers... this might take a moment,<br /> but it’s worth the wait!',
      'Still working... great scorecards aren’t built in a second!',
      'Almost there... we’re giving these scorecards the VIP treatment.',
      'Hold on... double-checking everything so you don’t have to.',
      'Final stretch... your scorecards are getting their<br /> finishing touches!',
    ]

    let currentNameIndex = 0
    const intervalId = setInterval(() => {
      setRcDownloadButtonName(downloadButtonNames[currentNameIndex])
      currentNameIndex = (currentNameIndex + 1) % downloadButtonNames.length
    }, 3000)
    const testType = record?.paper?.product?.type?.toLowerCase() || 'tq'
    try {
      const candidates = evaluationDetails?.data || []
      if (candidates.length > 0) {
        const exportData = candidates.map((eva: any) => {
          const candidateDetails = candiateReportcardDetails.find(
            ({ candidate_id }: any) => candidate_id === eva.application_id
          )
          const hasResult = hasGeneratedReportCard(candidateDetails)
          return {
            Name: eva?.candidate_name || candidateDetails?.candidate_name || '',
            Candidate_Id: eva?.application_id || '',
            Score_Card_Url: hasResult
              ? getMobileReportCardDownloadUrl(eva.application_id, testType)
              : 'NOT FOUND (Please confirm if the results have been generated or re-download the scorecard)',
          }
        })

        const notFoundCount = exportData.filter((row: { Score_Card_Url: string }) => row.Score_Card_Url.startsWith('NOT FOUND')).length

        if (exportData.length > 0 && notFoundCount !== exportData.length) {
          Modal.confirm({
            title: 'Confirm Excel Sheet Download',
            content: (
              <>
                <p>Scorecard download links are ready.</p>
                {notFoundCount > 0 && <p>{notFoundCount} candidates do not have generated results yet.</p>}
                <p>Do you want to download the scorecards as an Excel sheet?</p>
              </>
            ),
            okText: 'Yes, Download',
            cancelText: 'Cancel',
            onOk: () =>
              exportToExcel(exportData, `${record?.name}_evaluation_score_card_${Math.round(new Date().getTime() / 1000)}.xlsx`),
          })
        } else {
          message.error(
            <>
              Before downloading the scorecard,
              <br /> please confirm that at least one result has been generated!
            </>
          )
        }
      }
    } catch (err) {
      console.log(err, ':Error while downloading score cards')
      message.error('Something went wrong,Please try again later')
    } finally {
      setRcDownloading(false)
      setRcDownloadButtonName('')
      clearInterval(intervalId)
    }
  }

  return (
    <>
      <PageHeader
        className={`site-page-header-responsive `}
        ghost={false}
        title={`${record?.name}`}
        extra={[
          <Space className={`align ${background}`}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
                  Back
                </Button>
                {userRole === 'evaluationincharge' && queryResult?.data?.data?.evaluation_request?.status === 'Open' && evaluators.length > 0 && (
                  <Button hidden={showVerifyBtn()} type="primary" key="create" onClick={() => verifyAndNext()} icon={<Icons.RightOutlined />}>
                    Verified & Proceed
                  </Button>
                )}
                {(userRole && userRole === 'evaluationincharge') || userRole === 'productmanager' || userRole === 'admin' ? (
                  <Button loading={resultGreneration} onClick={() => storeAllResultsOfCandidate(evaluationDetails?.data)}>
                    Generate Result
                  </Button>
                ) : (
                  ''
                )}
                {(queryResult?.data?.data?.paper?.product?.type === 'skt' && userRole === 'evaluationincharge') ||
                (queryResult?.data?.data?.paper?.product?.type === 'skt' && userRole === 'productmanager') ||
                (queryResult?.data?.data?.paper?.product?.type === 'skt' && userRole === 'admin') ? (
                  <ExportButton onClick={triggerExport}>SKT Details</ExportButton>
                ) : (
                  ''
                )}
              </div>
              <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                {(userRole && userRole === 'evaluationincharge') || userRole === 'productmanager' || userRole === 'admin' ? (
                  <Button type="dashed" loading={reportGenerate} onClick={generateBulkReport}>
                    {bulkReportData ? (
                      <CSVLink
                        key="export"
                        data={bulkReportData}
                        filename={`candidate_results_paper/${record?.paper?.paper_smart_id}/_${Math.round(new Date().getTime() / 1000)}.csv`}
                      >
                        {' '}
                        <DownloadOutlined
                          style={{
                            marginRight: '2px',
                            animation: 'bounce 2s infinite',
                          }}
                        />{' '}
                        Download File
                      </CSVLink>
                    ) : (
                      'Export Data'
                    )}
                  </Button>
                ) : (
                  ''
                )}
                {userRole === 'evaluators' && evaluatorData?.status === 'Open' ? <Button onClick={() => exportData()}>Format</Button> : null}
                <Tooltip
                  title={
                    <>
                      <b>Note:</b> you can download the report card only if the candidate results are generated.
                      <br />
                      Please generate the results before attempting to download.
                    </>
                  }
                >
                  {/* <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Button
                      type="dashed"
                      icon={<Icons.FilePdfTwoTone />}
                      loading={rcDownloadLoading}
                      onClick={() => downloadScoreCards(evaluationDetails?.data)}
                    >
                      Generate Scorecards
                    </Button>
                  </div> */}
                </Tooltip>
              </div>
              <p
                style={{ fontSize: '12px', textAlign: 'center', animation: 'fadeIn 2s ease-in-out' }}
                dangerouslySetInnerHTML={{ __html: rcDownloadButtonName }}
              ></p>
            </div>

            <div className="upload-btn-wrapper1" style={{ display: createPermission !== undefined && createPermission?.granted ? 'block' : 'none' }}>
              {userRole === 'evaluators' &&
                (evaluatorData?.status === 'Open' ? (
                  <>
                    <button className="btnshow">Upload a file</button>
                    <input type="file" name="myfile" id={'csvFileInput'} accept={'.csv'} onChange={handleOnChange} />
                  </>
                ) : null)}
            </div>
          </Space>,
        ]}
      >
        <Descriptions size="small">
          <Descriptions.Item label="Name">{record?.name}</Descriptions.Item>
          {userRole === 'evaluators' && <Descriptions.Item label="Status">{<Tag color="blue">{evaluatorData?.status}</Tag>}</Descriptions.Item>}
          <Descriptions.Item label="Paper">{`#${record?.paper?.paper_id}-${record?.paper?.paper_smart_id}`}</Descriptions.Item>
          <Descriptions.Item label="Total Mark">{`${record?.paper?.product?.total_marks}`}</Descriptions.Item>
        </Descriptions>
        <Divider style={{ margin: ' 0', paddingBottom: 20 }} />
        {userRole !== 'evaluators' && (
          <Form form={form} onFinish={onFinish}>
            <Row style={{ display: !hasSelected ? 'none' : 'flex' }} gutter={[16, 0]}>
              <Col lg={10}>
                <Form.Item label="Evaluators" name="evaluator_id" rules={[{ required: true }]}>
                  <Select
                    disabled={!hasSelected}
                    onChange={value => {
                      handleEvaluatorChange(value)
                    }}
                  >
                    {availableEvaluators?.map(evalUser => (
                      <option key={evalUser?.id} value={evalUser?.id}>
                        {evalUser?.displayName}
                      </option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Space>
                  <Button type="primary" htmlType="submit">
                    Assign
                  </Button>
                  <Button
                    type="primary"
                    danger={editMode ? true : false}
                    icon={editMode ? <Icons.CloseOutlined /> : <></>}
                    onClick={() => {
                      setEditMode(editFlag => !editFlag)
                    }}
                  >
                    {editMode ? 'Cancel' : 'Show all evaluators'}
                  </Button>
                  <Popconfirm
                    title="Are you sure you want to remove the selected candidates' scorecard links?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={async () => {
                      if (evaluationDetails?.data?.data && evaluationDetails?.data?.data?.length > 0 && candiateReportcardDetails.length > 0) {
                        const matchedEvaluations = evaluationDetails.data.data.filter(item => selectedRowKeys.includes(item.id))

                        const selectedDetails: any = matchedEvaluations
                          .map(candidate => {
                            const selectedCandidate = candiateReportcardDetails.find((item: any) => item.candidate_id === candidate.application_id)
                            return selectedCandidate?.score_card_url
                              ? { candidateId: candidate.application_id, url: selectedCandidate.score_card_url }
                              : null
                          })
                          .filter(Boolean)
                        if (selectedDetails.length > 0) {
                          try {
                            const res = await deleteReportCardLinks(selectedDetails)
                            if (res.status && record) {
                              await getCandidateEvaluationDetails(record.id)
                              message.success("The selected candidates' scorecard links have been successfully removed.")
                            } else {
                              message.error("Failed to remove the selected candidates' scorecard links. Please try again.")
                            }
                          } catch (err) {
                            message.error('Server down!')
                          }
                        } else {
                          message.info('There are no scorecard links to remove.')
                        }
                      } else {
                        message.info('No candidates found.')
                      }
                    }}
                  >
                    <Button icon={<Icons.DeleteFilled />}>RC link</Button>
                  </Popconfirm>
                </Space>
              </Col>
              <Col lg={10}>
                <span style={{ marginLeft: 8 }}>{hasSelected ? `Selected ${selectedRowKeys.length} candidates` : ''}</span>
              </Col>
            </Row>
          </Form>
        )}
        <Divider style={{ margin: ' 0', paddingBottom: 5, marginTop: 20 }} />
        <b>Candidate Details</b>
        <div style={{ height: 10 }}></div>
        <Spin spinning={loading} tip="Wait..." />
        <Table
          className={`${background}`}
          size="small"
          columns={columns}
          dataSource={evaluationDetails?.data?.data}
          rowSelection={rowSelection}
          rowKey="id"
          loading={evaluationDetails?.isFetching}
          scroll={{ x: 'max-content' }}
          //   pagination={{
          //     total: tableTotal,
          //     onChange,
          //   }}
        />
        {userRole === 'evaluators' &&
          (evaluatorData?.status !== 'Verified' ? (
            <Button type="primary" key="create" onClick={() => finalVerify()} icon={<Icons.RightOutlined />}>
              Verified
            </Button>
          ) : null)}
      </PageHeader>
      <ShowCandidate visible={showModal} record={details} hideModal={handleCancel} eval_details={record} />
    </>
  )
}
